import { Injectable } from '@angular/core';

export type AdminActiveSection =
  'airports'
  | 'services'
  | 'bookings'
  | 'languages'
  | 'countries'
  | 'cities'
  | 'airport-services'
  | 'main-screen-images';

export interface AdminTableState {
  activeSection: AdminActiveSection;
  page: number;
  size: number;
  sort: string;
  search: string;
  currentSortHeader: string;
  currentSort: string;
  airportIdSearch: string;
}

const ADMIN_TABLE_STATE_KEY = 'admin-table-state';

@Injectable({
  providedIn: 'root'
})
export class AdminTableStateService {

  save(state: AdminTableState): void {
    sessionStorage.setItem(ADMIN_TABLE_STATE_KEY, JSON.stringify(state));
  }

  load(): AdminTableState | null {
    const raw = sessionStorage.getItem(ADMIN_TABLE_STATE_KEY);

    if (!raw) {
      return null;
    }

    try {
      return JSON.parse(raw) as AdminTableState;
    } catch {
      this.clear();
      return null;
    }
  }

  clear(): void {
    sessionStorage.removeItem(ADMIN_TABLE_STATE_KEY);
  }
}
